const rawUrl = process.env.NEXT_PUBLIC_SITE_URL ?? "https://submify.nodedr.com";

export const site = {
  name: "Submify",
  shortName: "Submify",
  legalName: "NODEDR INFOTECH PRIVATE LIMITED",
  ownerName: "Raktim Ranjit",
  tagline: "Self-hosted form backend as a service",
  description:
    "Submify is a self-hosted Form-Backend-as-a-Service. POST JSON from any HTML form or static site, then manage submissions, exports, Telegram alerts, and S3 uploads from your own dashboard — on your own infrastructure.",
  url: rawUrl.replace(/\/$/, ""),
  email: "info@nodedr.com",
  nodedrUrl: "https://www.nodedr.com",
  repoUrl: "https://github.com/Raktim94/Submify",
  repoIssuesUrl: "https://github.com/Raktim94/Submify/issues",
  installerUrl: "https://raw.githubusercontent.com/Raktim94/Submify/main/install.sh",
  apiDocsUrl: "https://github.com/Raktim94/Submify/blob/main/docs/api.md",
  licenseUrl: "https://github.com/Raktim94/Submify/blob/main/LICENSE",
  formName: "Submify contact",
  submitPath: "/api/submit",
  thankYouPath: "/thank-you",
  ogImage: "/brand/submify-logo.png",
  debVersion: "0.4.1",
  installLinuxUrl: "https://submify.nodedr.com/install-linux.sh",
  debAmd64Url: "/downloads/submify-amd64.deb",
  debArm64Url: "/downloads/submify-arm64.deb",
} as const;

export function absoluteUrl(path: string): string {
  return new URL(path, site.url).toString();
}
